import { useTranslation } from 'react-i18next';

import { Waveform } from '../waveform/waveform';

import styles from './audio-overlay.module.css';

type Props = {
  isPlaying?: boolean;
  isStopped?: boolean;
  coverSource?: AudioCoverSource;
};

export type AudioCoverSource = {
  src: string;
  set: AudioCoverSetSource[];
};

export type AudioCoverSetSource = {
  src: string;
  media: string;
};

export function AudioOverlay({ isPlaying = false, isStopped = true, coverSource }: Props) {
  const { t } = useTranslation();

  return coverSource ? (
    <picture data-testid="audio-image-overlay" className={styles.picture}>
      {coverSource.set.map((set) => (
        <source key={set.src} srcSet={set.src} media={set.media} />
      ))}
      <img src={coverSource.src} alt={t('ui.audio-image-overlay.alt')} className={styles.image} />
    </picture>
  ) : (
    <div className={styles.wrapper} data-testid="audio-animation-overlay">
      <Waveform isPlaying={isPlaying} isStopped={isStopped} />
    </div>
  );
}
